import { EditAdmin } from "../../components/admins/EditAdmin.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
export const AdminEditPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Admins <BreadCrumbSign /> Update
          </p>
          <EditAdmin />
        </div>
      </div>
    </div>
  );
};
